import { LoggerImpl } from "./LoggerImpl";
/**
 * Global logger instance that you should use for logging.
 *
 * Use `setStream` to configure the destinations for the logs.
 * Use `setGlobalContext` to configure global context that should be
 * included in every log, such as information about the user.
 */
export const logger = new LoggerImpl();
/**
 * Sets the destination for all logs.
 */
export const setStream = (stream) => {
    LoggerImpl.stream = stream;
};
/**
 * Sets context that should be included in every log, such as information
 * about the user.
 */
export const setGlobalContext = (context) => {
    LoggerImpl.globalContext = context;
};
//# sourceMappingURL=index.js.map